var echarts = require("../echarts");

require("./lines/LinesSeries");

require("./lines/LinesView");

var linesLayout = require("./lines/linesLayout");

var linesVisual = require("./lines/linesVisual");

echarts.registerLayout(linesLayout);
echarts.registerVisual(linesVisual);


//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/chart/lines.js
// module id = 952
// module chunks = 0